import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import GlobalLockModal from './globallockmodal';
import MasterPassword from './masterpassword';
import ToastHandler from '../../components/toasthandler';
import Loader from '../../components/loader';
import Modal from '../../components/modal';

import Web3Modal from "web3modal";
import { ethers } from 'ethers';
import { SiweMessage } from 'siwe'
import WalletConnectProvider from "@walletconnect/web3-provider";
import WalletLink from 'walletlink';

import {
  fetchSecurity,
  fetchNonceForSIWE,
  toggleSIWE
} from '../../actions';

const providerOptions = {
  'custom-coinbase': {
    display: {
      logo: process.env.REACT_APP_CDN + '/assets/images/brands/coinbase.svg',
      name: 'Coinbase',
      description: 'Scan with WalletLink to connect',
    },
    options: {
      appName: 'Sign-In with Ethereum',
      networkUrl: `https://mainnet.infura.io/v3/${process.env.REACT_APP_WEB3_MODAL_INFURA_ID}}`,
      chainId: 1,
      darkMode: false,
    },
    package: WalletLink,
    connector: async (_, options) => {
      const { appName, networkUrl, chainId, darkMode } = options;
      const walletLink = new WalletLink({
        appName,
        darkMode,
      });
      const provider = walletLink.makeWeb3Provider(networkUrl, chainId);
      await provider.enable();
      return provider;
    },
  },
  walletconnect: {
    package: WalletConnectProvider,
    options: {
      infuraId: process.env.REACT_APP_WEB3_MODAL_INFURA_ID,
    }
  },
};

const web3Modal = new Web3Modal({
  providerOptions,
  cacheProvider: false,
  disableInjectedProvider: false,
});

var instance, provider, signer;

class SignInWithEthereum extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      newPassword: '',
      modalComponent: null,
      wideModal: false,
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchSecurity());
  }

  toggleModal(component, wideModal) {
    this.setState({
      modalComponent: component,
      wideModal: wideModal,
    });
  }

  async createSiweMessage(address, statement, nonce) {
    const message = new SiweMessage({
      domain: window.location.host,
      address,
      statement,
      uri: window.location.origin,
      version: '1',
      chainId: '1',
      nonce: nonce
    });
    return message.prepareMessage();
  }

  async signInWithEthereum(nonce, siweEnabled) {
    const { dispatch } = this.props;

    const message = await this.createSiweMessage(
      await signer.getAddress(),
      'Sign in with Ethereum to the app.',
      nonce
    );

    let type;


    if (siweEnabled){
      type = 'disableSiwe';
    } else {
      type = 'enableSiwe';
    }

    const signature = await signer.signMessage(message);

    const data = {
      signature,
      message,
      type,
    }

    // alert(signature)
    dispatch(toggleSIWE(data))
      .then((res) => {
        if (res.type === 'TOGGLE_SIWE_SUCCESS') {
          dispatch(fetchSecurity());
        }
      });
  }

  async connectWallet() {
    web3Modal.clearCachedProvider()
    instance = await web3Modal.connect();

    provider = new ethers.providers.Web3Provider(instance);
    signer = provider.getSigner();

    // this.signInWithEthereum()
    const { dispatch } = this.props;
    dispatch(fetchNonceForSIWE());
  }

  render() {
    const { user, errors, success, siweNonce, tempAnon } = this.props;
    const { password, newPassword } = this.state;

    let siweEnabled;
    let siweEthAddress;
    if (user.security) {
      const siweHandle = user.security.find(e => e.typeHandle === 'SIWE');
      if (siweHandle && siweHandle.statusHandle === 'ACTIVATED') {
        siweEnabled = true;
        siweEthAddress = siweHandle.ethAddress;
      }
    }

    if(siweNonce){
      // this condition will run when a nonce has already been fetched from the api
      this.signInWithEthereum(siweNonce,siweEnabled)
    }

    if (!user.security) {
      return (
        <div className="center-loader">
          <Loader logo />
        </div>
      );
    }

    return (
      <div className="grid-x">
        <ToastHandler errors={errors} success={success} />
        {this.state.modalComponent &&
          <Modal noclose={user.resetCode} toggleModal={this.toggleModal} modalComponent={this.state.modalComponent} wideModal={this.state.wideModal} />
        }
        <div className="cell small-12 medium-12 large-12" style={{marginBottom: 20}}>
          <a className="backlink" href="/settings">
            <FontAwesomeIcon
              size="sm"
              icon={faChevronLeft}
            />
            &nbsp;
            Back to Settings
          </a>
        </div>
        <div className="cell panel v2 small-12 medium-12 large-12">
          <div className="panel-label">
            Sign In With Ethereum
          </div>
          <p className="mute">
            Use your Ethereum address to sign in and access your Vaultoro account.
          </p>
          <hr/>
          <div className="grid-x align-middle">
            <div className="cell small-6 medium-6 large-6">
              <div>Sign In With Ethereum</div>
            </div>
            <div className="cell small-6 medium-6 large-6 flex-end">
              <div>
                <div
                  onClick={() => this.connectWallet()}
                  className={siweEnabled ? 'vlt-switch on' : 'vlt-switch off'}
                >
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
          {siweEnabled ? (
            <>
              <hr />
              <div className="grid-x group">
                <div className="cell small-12 medium-6 large-6">
                  <div>Authenticated Address</div>
                </div>
                <div className="cell small-12 medium-6 large-6 flex-end-md">
                  <div>
                    <span className={tempAnon ? 'eyeblur' : ''}>
                      {
                        siweEthAddress
                      }
                    </span>
                  </div>
                </div>
              </div>
            </>
          ) : (null)}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  siweNonce: state.user.siweNonce,
  tempAnon: state.user.tempAnon,
  errors: state.user.errors,
  success: state.user.success,
});

export default connect(mapStateToProps)(SignInWithEthereum);
